import gql from 'graphql-tag'

export default gql`
  mutation PriceCreateMutation($name: String!, $conversions: [PriceConversionInput!]!) {
    priceCreate(name: $name, conversions: $conversions) {
      id
    }
  }
`
